import GameModel from "../../GameModel";
import LightSourceCreators from "../lighting/LightSourceCreators";
import { SoundEffects } from "../sound/SoundEffects";
import GervaisAnimatedSpritesheet from "../sprite/GervaisAnimatedSpritesheet";
import { GervaisSpriteNames } from "../sprite/GervaisSpriteNames";
import BasicSpriteEffectCache from "./BasicSpriteEffectCache";
import BasicSpriteEffectCreator from "./BasicSpriteEffectCreator";

export default class EffectCreators extends GameModel {
    /**
     * @param {LightSourceCreators} lightSourceCreators 
     * @param {GervaisAnimatedSpritesheet} spellFxSpritesheet
     */
    constructor(lightSourceCreators, spellFxSpritesheet) {
        super();

        /**
         * @constant
         * @type {BasicSpriteEffectCache}
         */
        this.basicSpriteEffectCache = new BasicSpriteEffectCache();

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGreenSkull = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GREEN_SKULL, 
            SoundEffects.damage, lightSourceCreators.darkGreenFlickering, this.basicSpriteEffectCache);


        ///////////////////////////////////////////////////////
        // Damage Effects
        ///////////////////////////////////////////////////////

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectBloodSplatter = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_RED_SPLAT, 
            SoundEffects.damage, null, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectRedDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_RED_DAMAGE, 
            SoundEffects.damage,
            lightSourceCreators.red, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectWhiteDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_WHITE_DAMAGE, 
            SoundEffects.damage, lightSourceCreators.white, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectBlueDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_BLUE_DAMAGE, 
            SoundEffects.damage,
            lightSourceCreators.darkBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectGreenDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_GREEN_DAMAGE, 
            SoundEffects.damage,
            lightSourceCreators.lightGreen, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectShockDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_SHOCK_DAMAGE, 
            SoundEffects.damage,
            lightSourceCreators.lightBlueFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectFireDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_FIRE_DAMAGE, 
            SoundEffects.damage,
            lightSourceCreators.orange, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectPoisonDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_POISON_DAMAGE, 
            SoundEffects.damage,
            lightSourceCreators.darkGreen, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectSonicDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_SONIC_DAMAGE, 
            SoundEffects.damage,
            lightSourceCreators.peach, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.damageEffectPinkDamage = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.DAMAGE_EFFECT_NAME_PINK_DAMAGE, 
            SoundEffects.damage,
            null, this.basicSpriteEffectCache
        ); /* lightSourceCreators.peach */

        ///////////////////////////////////////////////////////
        // Spell Effects: SpellFXAnim1
        ///////////////////////////////////////////////////////

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSparkleGold = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SPARKLE_GOLD, 
            SoundEffects.damage,
            lightSourceCreators.yellowFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSparkleGreen = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SPARKLE_GREEN, 
            SoundEffects.damage,
            lightSourceCreators.darkGreenFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSparkleBlue = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SPARKLE_BLUE, 
            SoundEffects.damage,
            lightSourceCreators.lightBlueFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSparklePink = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SPARKLE_PINK, 
            SoundEffects.damage,
            lightSourceCreators.peachFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSparkleOrange = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SPARKLE_ORANGE, 
            SoundEffects.damage,
            lightSourceCreators.redFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSparkleRed = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SPARKLE_RED, 
            SoundEffects.damage,
            null, this.basicSpriteEffectCache
        );  // removed: lightSourceCreators.redFlickering

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGreenSkull = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GREEN_SKULL, 
            SoundEffects.damage,
            lightSourceCreators.darkGreenFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectYellowKey = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_YELLOW_KEY, 
            SoundEffects.damage,
            lightSourceCreators.peachFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSkullCross = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SKULL_CROSS, 
            SoundEffects.damage,
            lightSourceCreators.darkRed, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectShields = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SHIELDS, 
            SoundEffects.damage,
            lightSourceCreators.darkBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectRedCrosses = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_RED_CROSSES, 
            SoundEffects.damage,
            lightSourceCreators.yellow, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectFireRing = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_FIRE_RING, 
            SoundEffects.damage,
            lightSourceCreators.orange, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectIceRing = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_ICE_RING, 
            SoundEffects.damage,
            lightSourceCreators.lightBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGreenRing = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GREEN_RING, 
            SoundEffects.damage,
            lightSourceCreators.lightGreen, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectPinkRing = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_PINK_RING, 
            SoundEffects.damage,
            lightSourceCreators.peach, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectYellowStar = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_YELLOW_STAR, 
            SoundEffects.damage,
            null, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectBlueStar = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_BLUE_STAR, 
            SoundEffects.damage,
            lightSourceCreators.lightBlueFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGreenStar = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GREEN_STAR, 
            SoundEffects.damage,
            lightSourceCreators.lightGreenFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectWhiteCrosses = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_WHITE_CROSSES, 
            SoundEffects.damage,
            lightSourceCreators.cyan, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectWeb = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_WEB, 
            SoundEffects.damage,
            null, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectTorch = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_TORCH, 
            SoundEffects.damage,
            lightSourceCreators.orange, this.basicSpriteEffectCache
        );

        ///////////////////////////////////////////////////////
        // Spell Effects: SpellFXAnim2
        ///////////////////////////////////////////////////////

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectFrost = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_FROST, 
            SoundEffects.damage,
            lightSourceCreators.white, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectYellowStarCircle = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_YELLOW_STAR_CIRCLE, 
            SoundEffects.damage,
            null, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectCircles = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_CIRCLES, 
            SoundEffects.damage,
            lightSourceCreators.peach, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGoldShieldSpiral = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GOLD_SHIELD_SPIRAL, 
            SoundEffects.damage,
            lightSourceCreators.yellow, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGreenShieldSpiral = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GREEN_SHIELD_SPIRAL, 
            SoundEffects.damage,
            lightSourceCreators.lightGreen, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectBlueShieldSpiral = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_BLUE_SHIELD_SPIRAL, 
            null,
            lightSourceCreators.lightBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectPinkShieldSpiral = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_PINK_SHIELD_SPIRAL, 
            SoundEffects.damage,
            lightSourceCreators.peach, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectBlueFirework = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_BLUE_FIREWORK, 
            SoundEffects.damage,
            lightSourceCreators.lightBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectRedFirework = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_RED_FIREWORK, 
            SoundEffects.damage,
            lightSourceCreators.red, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectStun = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_BUBBLES, 
            SoundEffects.damage,
            lightSourceCreators.peachFlickering, this.basicSpriteEffectCache
        );

        ///////////////////////////////////////////////////////
        // Spell Effects: SpellFXAnim3
        ///////////////////////////////////////////////////////

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectShield = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SHIELD, 
            SoundEffects.damage,
            lightSourceCreators.lightGray, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.colorSpiralEffect = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_COLOR_SPIRAL, 
            SoundEffects.damage,
            lightSourceCreators.white, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectArmFlex = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_ARM_FLEX, 
            SoundEffects.damage,
            lightSourceCreators.lightBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSuperSpeed = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SUPER_SPEED, 
            SoundEffects.damage,
            lightSourceCreators.yellow, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectTarget = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_TARGET, 
            SoundEffects.damage,
            lightSourceCreators.red, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectYellowShieldSpiral = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_YELLOW_SHIELD_SPIRAL, 
            SoundEffects.damage,
            lightSourceCreators.yellow, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectPinkStarCircle = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_PINK_STAR_CIRCLE, 
            SoundEffects.damage,
            lightSourceCreators.peach, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectBlueStarCircle = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_BLUE_STAR_CIRCLE, 
            SoundEffects.damage,
            lightSourceCreators.lightBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGreenStarCircle = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GREEN_STAR_CIRCLE, 
            SoundEffects.damage,
            lightSourceCreators.lightGreen, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGoldStarCircle = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GOLD_STAR_CIRCLE, 
            SoundEffects.damage,
            lightSourceCreators.yellow, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectBread = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_BREAD, 
            SoundEffects.damage,
            lightSourceCreators.peach, this.basicSpriteEffectCache
        );

        ///////////////////////////////////////////////////////
        // Spell Effects: SpellFXAnim4
        ///////////////////////////////////////////////////////

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectYellowFireFing = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_YELLOW_FIRE_RING, 
            SoundEffects.damage,
            lightSourceCreators.yellow, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectTotems = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_TOTEMS, 
            SoundEffects.damage,
            lightSourceCreators.peach, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectEyeBlink = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_EYE_BLINK, 
            SoundEffects.damage,
            lightSourceCreators.orange, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectPinkStar = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_PINK_STAR, 
            SoundEffects.damage,
            lightSourceCreators.peachFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectOrangeStar = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_ORANGE_STAR, 
            SoundEffects.damage,
            lightSourceCreators.yellowFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectRedEyeBlink = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_RED_EYE_BLINK, 
            SoundEffects.damage,
            lightSourceCreators.red, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectEagle = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_EAGLE, 
            SoundEffects.damage,
            lightSourceCreators.lightBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectSleep = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_SLEEP, 
            null,
            lightSourceCreators.orange, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectArmor = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_ARMOR, 
            SoundEffects.damage,
            lightSourceCreators.red, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectBlindEyeBlink = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_BLIND_EYE_BLINK, 
            SoundEffects.damage,
            lightSourceCreators.lightBlue, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectFireRain = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_FIRE_RAIN, 
            SoundEffects.damage,
            lightSourceCreators.yellowFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectBlueRain = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_BLUE_RAIN, 
            SoundEffects.damage,
            lightSourceCreators.lightBlueFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectGreenRain = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_GREEN_RAIN, 
            SoundEffects.damage,
            lightSourceCreators.lightGreenFlickering, this.basicSpriteEffectCache
        );

        ///////////////////////////////////////////////////////
        // Spell Effects: SpellFXAnim5
        ///////////////////////////////////////////////////////

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectLightningRain = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_LIGHTNING_RAIN, 
            SoundEffects.damage,
            lightSourceCreators.yellowFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectPinkRain = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_PINK_RAIN, 
            SoundEffects.damage,
            lightSourceCreators.peachFlickering, this.basicSpriteEffectCache
        );

        /**
         * @constant
         * @type {BasicSpriteEffectCreator}
         */
        this.effectRainbowRain = new BasicSpriteEffectCreator(
            spellFxSpritesheet, GervaisSpriteNames.EFFECT_NAME_RAINBOW_RAIN, 
            SoundEffects.damage,
            lightSourceCreators.yellowFlickering, this.basicSpriteEffectCache
        );

    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.basicSpriteEffectCache.resetCache();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.resetFull();
    }

}